import { render, staticRenderFns } from "./TipoSolicitud.html?vue&type=template&id=45f9c7d8&external"
import script from "./TipoSolicitud.vue?vue&type=script&lang=js"
export * from "./TipoSolicitud.vue?vue&type=script&lang=js"
import style0 from "./TipoSolicitud.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports